const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled: "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
          redirecting: "Redirecionando para o pagamento...",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          confirmPassword: "Confirmar Senha",
          passwordRequirements: "Mínimo 8 caracteres, 1 maiúscula, 1 número e 1 caractere especial",
          company: "Nome da Organização",
          phone: "WhatsApp (com código do país)",
          phoneHelper: "Ex: +55 11 99999-9999",
          document: "CPF ou CNPJ",
          documentHelper: "Digite CPF (11 dígitos) ou CNPJ (14 dígitos)",
          plan: "Plano",
          paymentMethod: "Forma de pagamento",
          installments: "Parcelas",
          installmentsHelper: "Divida o valor total em até {{max}} parcelas no cartão de crédito.",
          installmentsOption: "{{count}}x de R$ {{value}}",
          installmentsOptionSingle: "À vista — R$ {{value}}",
          planTotal: "Valor total do plano: R$ {{value}}",
        },
        paymentOptions: {
          pix: "PIX",
          boleto: "Boleto bancário",
          card: "Cartão de crédito",
        },
        consent: {
          label: "Concordo que meu plano será renovado automaticamente no final de cada período.",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
        validation: {
          cpfValid: "CPF válido!",
          cpfInvalid: "CPF inválido! Verifique os dígitos.",
          cnpjValid: "CNPJ válido! Nome da empresa preenchido automaticamente.",
          cnpjInvalid: "CNPJ inválido! Verifique os dígitos.",
          cnpjNotFound: "CNPJ não encontrado na Receita Federal.",
          cnpjWarning: "CNPJ válido, mas não foi possível consultar a Receita Federal.",
          cnpjError: "Erro ao validar documento. Tente novamente.",
          phoneInvalid: "Número de WhatsApp inválido",
          phoneRequired: "WhatsApp é obrigatório",
          planRequired: "Selecione um plano",
          paymentRequired: "Selecione uma forma de pagamento",
          consentRequired: "Você precisa aceitar a renovação automática para continuar",
          installmentsRequired: "Selecione o número de parcelas",
          passwordRequired: "Senha é obrigatória",
          passwordMin: "A senha deve ter pelo menos 8 caracteres",
          passwordMax: "Senha muito longa",
          passwordUppercase: "A senha deve conter pelo menos 1 letra maiúscula",
          passwordNumber: "A senha deve conter pelo menos 1 número",
          passwordSpecialChar: "A senha deve conter pelo menos 1 caractere especial",
          passwordMatch: "As senhas não coincidem",
          confirmPasswordRequired: "Confirme sua senha",
          nameMin: "Nome muito curto",
          nameMax: "Nome muito longo",
          nameRequired: "Nome é obrigatório",
          companyNameMin: "Nome da organização muito curto",
          companyNameMax: "Nome da organização muito longo",
          companyNameRequired: "Nome da organização é obrigatório",
          documentRequired: "CPF ou CNPJ é obrigatório",
          emailInvalid: "E-mail inválido",
          emailRequired: "E-mail é obrigatório",
        },
      },
      subscription: {
        form: {
          installments: "Parcelas",
          installmentsHelper: "Divida o valor total em até {{max}} parcelas no cartão de crédito.",
          installmentsOption: "{{count}}x de R$ {{value}}",
          installmentsOptionSingle: "À vista — R$ {{value}}",
        },
        warnings: {
          pickInstallments: "Selecione o número de parcelas.",
        },
        cancel: {
          button: "Cancelar assinatura",
          title: "Cancelar assinatura",
          body: "Você continuará com acesso ao sistema até {{date}}. Após essa data sua conta ficará inativa e nenhuma cobrança será feita automaticamente. Você poderá reativar a qualquer momento escolhendo um novo plano.",
          confirm: "Tem certeza que deseja cancelar?",
          back: "Voltar",
          confirmButton: "Confirmar cancelamento",
          success: "Assinatura cancelada com sucesso.",
          successWithDate: "Assinatura cancelada. Você terá acesso até {{date}}.",
        },
        reactivate: {
          button: "Reativar assinatura",
          title: "Reativar assinatura",
          body: "Sua assinatura será reativada. A próxima renovação será cobrada automaticamente em {{date}}.",
          back: "Voltar",
          confirmButton: "Confirmar reativação",
          success: "Assinatura reativada.",
          successWithDate: "Assinatura reativada. A próxima renovação será em {{date}}.",
        },
        pixBoletoNote: "Planos pagos por PIX ou Boleto não têm cobrança automática. Para parar de renovar, basta não pagar a próxima fatura.",
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
        invalidPhoneFormat: "Formato de telefone inválido",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
          forgotPassword: "Esqueceu sua senha?",
        },
        forgotPassword: {
          title: "Esqueceu sua senha?",
          subtitle: "Digite seu email e enviaremos um código de verificação.",
          sendCode: "Enviar Código",
          backToLogin: "Voltar ao login",
        },
        resetPassword: {
          title: "Redefinir sua senha",
          subtitle: "Digite o código enviado para seu email e sua nova senha.",
          codeLabel: "Código de Verificação",
          newPasswordLabel: "Nova Senha",
          submitButton: "Redefinir Senha",
        },
        mfa: {
          newPasswordRequired: "Defina uma nova senha para continuar",
          newPassword: "Nova senha",
          confirmPassword: "Confirmar",
          setupTitle: "Configure a autenticação de dois fatores",
          setupDescription: "Escaneie o QR code com seu aplicativo autenticador (Google Authenticator, Authy, etc.)",
          verificationCode: "Código de verificação",
          verify: "Verificar",
          verifyTitle: "Autenticação de dois fatores",
          verifyDescription: "Digite o código do seu aplicativo autenticador",
          backToLogin: "Voltar ao login",
        },
        mfaRecovery: {
          trigger: "Perdeu acesso ao autenticador?",
          requestTitle: "Recuperação de MFA",
          requestSubtitle: "Perdeu acesso ao seu aplicativo autenticador?",
          requestInfo: "Um código de 6 dígitos será enviado para",
          sendCode: "Enviar Código",
          cancel: "Cancelar",
          verifyTitle: "Digite o código de recuperação",
          verifySubtitle: "Enviamos um código de 6 dígitos para o seu email.",
          codeLabel: "Código de recuperação",
          verifyButton: "Verificar Código",
          back: "Voltar",
          requestNewCode: "Solicitar novo código",
          expiresIn: "O código expira em",
          expired: "Código expirado. Solicite um novo código.",
          successTitle: "MFA resetado com sucesso!",
          successBody: "A autenticação de dois fatores foi resetada. Você já pode fazer login novamente e configurar um novo autenticador.",
          successInfo: "Feche esta janela e faça login novamente — você vai precisar configurar um novo aplicativo autenticador.",
          redirecting: "Redirecionando em {{count}} segundos...",
          closeNow: "Fechar agora",
          toasts: {
            codeSent: "Código de recuperação enviado para o seu email!",
            resetSuccess: "MFA resetado com sucesso!",
          },
        },
        toasts: {
          passwordResetSuccess: "Senha redefinida com sucesso!",
          resetCodeSent: "Código de verificação enviado para o seu email!",
        },
      },
      companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
          expired: "Seu plano expirou. Escolha um plano para continuar.",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos",
        buttons: {
          downloadModel: "Baixar Modelo",
          closed: "Fechar",
          import: "Importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers: " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",
        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported: "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage: "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        bulkDelete: {
          noneSelected: "Selecione pelo menos uma conexão para excluir.",
          button: "Excluir Selecionadas ({{count}})",
          dialogTitle: "Excluir {{count}} conexão(ões) selecionada(s)?",
          dialogMessage: "Esta ação não poderá ser revertida.",
          toastSuccess: "{{count}} conexão(ões) excluída(s) com sucesso.",
          toastError: "{{count}} conexão(ões) não puderam ser excluídas.",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content: "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content: "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content: "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
        },
        facebook: {
          success: "Página do Facebook conectada com sucesso!",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait: "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Importar mensagens de grupo",
          closedTicketsPostImported: "Encerrar tickets após importação",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc: "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          msgSendQueue: "Mensagem ao redirecionar para fila (opcional)",
          importAlert: "ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS: "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS: "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage: "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime: "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket: "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          collectiveVacationSection: "Férias Coletivas",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
          queuesDisabledByIntegration: "Desabilitado porque esta conexão já usa Integração FlowLive (Entrada). Remova a integração para poder selecionar filas.",
          integrationDisabledByQueues: "Desabilitado porque esta conexão já possui filas selecionadas. Remova as filas para poder usar a Integração FlowLive (Entrada).",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue: "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS: "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage: "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
        waiting: "Aguardando QR Code...",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage: "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          country: "País",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
        duplicatesToast: {
          summary: "{{imported}} importados, {{duplicates}} duplicados",
          download: "Baixar duplicados",
        },
        importReport: {
          summary: "{{imported}} importados, {{duplicates}} duplicados, {{rejected}} não importados",
          download: "Baixar relatório",
          missingFields: "Campos obrigatórios ausentes: {{fields}}",
        },
        filters: {
          createdAt: "Criado em",
          to: "Até",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      contactModal: {
        validation: {
          birthDateMin: "Data de nascimento inválida",
          birthDateFuture: "Data de nascimento não pode ser no futuro",
        },
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
          attendant: "Atendente",
          customer_portfolio: "Carteira de Clientes",
          queue: "Fila",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage: "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete: "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração FlowLive (Entrada)",
          integrationTypeId: "Integração FlowLive (Encerramento)",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          selectRotationType: "Selecione o tipo de rodízio",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        toasts: {
          invalidForm: "Não foi possível salvar. Verifique os campos obrigatórios e as opções do chatbot.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip: "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle: "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent: "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
          flow: "Fluxo do FlowLive",
          flowNone: "Nenhum fluxo vinculado",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning: {
          updateImage: "A imagem será atualizada ao salvar",
        },
        password: {
          chars: "8+ caracteres",
          uppercase: "1 maiúscula",
          number: "1 número",
          special: "1 especial",
        },
        validation: {
          birthDateMin: "Data de nascimento inválida",
          birthDateFuture: "Data de nascimento não pode ser no futuro",
        },
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver fluxos",
          changeEmail: "Alterar Email",
          newEmail: "Novo Email",
          changePassword: "Alterar Senha",
          newPassword: "Nova Senha",
          confirmPassword: "Confirmar Senha",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
          saveEmail: "Salvar Email",
          savePassword: "Salvar Senha",
        },
        success: "Usuário salvo com sucesso.",
        successEmail: "Email atualizado com sucesso.",
        successPassword: "Senha atualizada com sucesso.",
        successProfile: "Perfil atualizado com sucesso.",
        errorPasswordMismatch: "As senhas não coincidem.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
        confirmationModal: {
          deleteMessage: "Tem certeza que deseja excluir este agendamento?",
          deleteTitle: "Excluir Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso!",
        },
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Coluna",
          editKanban: "Editar Coluna",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para coluna",
          nextLaneId: "Coluna",
          greetingMessageLane: "Mensagem de saudação da coluna",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Coluna após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Coluna salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
          bulkTransfer: "Transferir em Massa",
          selectAll: "Selecionar todos",
          deselectAll: "Desmarcar todos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: {
            title: "Abertas",
          },
          closed: {
            title: "Resolvidos",
          },
          search: {
            title: "Busca",
          },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Atendentes",
          selectAllUsers: "Selecionar todos",
          clearAllUsers: "Limpar seleção",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
        filters: {
          keyWord: "Palavra-chave",
          to: "Até",
          updatedAt: "Atualizado em",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar atendentes",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      bulkTransferTicketModal: {
        title: "Transferir {{count}} Ticket(s)",
        button: "Transferir ({{count}})",
        fieldLabelRequired: "Selecione um atendente (obrigatório)",
        toastSuccessSync: "{{count}} ticket(s) transferido(s) com sucesso.",
        toastCompleted: "{{transferred}} de {{total}} ticket(s) transferido(s) com sucesso.",
        toastError: "Erro ao transferir os tickets selecionados.",
        progressDialogTitle: "Transferindo Tickets",
        progressText: "{{current}} de {{total}} tickets transferidos",
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage: "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
          noQueuesWarning: "Você não está vinculado a nenhum setor. Peça a um administrador para te adicionar a um setor antes de aceitar este atendimento.",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas",
          tenant: "Tenant",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          subscription: "Assinatura",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "CRM",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          flowbuilder: "FlowLive",
          todoList: "Lista de Tarefas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token: "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1: "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2: "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions: "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions: "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
        aiTransfer: {
          title: "Novo contato na fila {{queue}}",
          titleNoQueue: "Contato transferido pelo Agente FlowLive (sem fila)",
        },
        ticketTransfer: {
          title: "Atendimento transferido para você",
        },
        unansweredReminder: {
          title: "Cliente aguardando resposta",
        },
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description: "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
          category: "Categoria",
          language: "Idioma",
          metaID: "Meta ID",
          status: "Status",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        duplicatesToast: {
          summary: "{{imported}} importados, {{duplicates}} duplicados",
          download: "Baixar duplicados",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Colunas",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa por nome",
        subMenus: {
          list: "Execução",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
        fetchError: "Erro ao buscar dados do relatório",
        backButton: "Voltar",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
        bulkDelete: {
          noneSelected: "Selecione pelo menos uma fila para excluir.",
          button: "Excluir Selecionadas ({{count}})",
          dialogTitle: "Excluir {{count}} fila(s) selecionada(s)?",
          dialogMessage: "Esta ação não poderá ser revertida. Os atendimentos das filas excluídas continuarão existindo sem fila atribuída.",
          toastSuccess: "{{count}} fila(s) excluída(s) com sucesso.",
          toastError: "{{count}} fila(s) não puderam ser excluídas.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      aiKnowledgeFiles: {
        toggleLabel: "Usar base de conhecimento (RAG)",
        hint: "Anexe PDFs (até 5MB cada) para a IA responder também com base no conteúdo deles.",
        uploadButton: "Enviar PDF",
        maxSizeLabel: "Máx. 5MB",
        saveNodeFirst: "Salve o nó primeiro para poder anexar arquivos.",
        status: {
          processing: "Processando...",
          ready: "Pronto",
          error: "Erro",
        },
        errors: {
          mustBePdf: "O arquivo deve ser um PDF.",
          tooLarge: "O arquivo excede o limite de 5MB.",
          missingApiKey: "Informe a API Key antes de anexar arquivos.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          flow: "Fluxo",
          noFlow: "Nenhum fluxo vinculado",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Integração",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
        toasts: {
          deleted: "Integração excluída com sucesso!",
        },
        bulkDelete: {
          noneSelected: "Selecione pelo menos uma integração para excluir.",
          button: "Excluir Selecionadas ({{count}})",
          dialogTitle: "Excluir {{count}} integração(ões) selecionada(s)?",
          dialogMessage: "Esta ação não poderá ser revertida.",
          toastSuccess: "{{count}} integração(ões) excluída(s) com sucesso.",
          toastError: "{{count}} integração(ões) não puderam ser excluídas.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
        bulkDelete: {
          noneSelected: "Selecione pelo menos um usuário para excluir.",
          button: "Excluir Selecionados ({{count}})",
          dialogTitle: "Excluir {{count}} usuário(s) selecionado(s)?",
          dialogMessage: "Esta ação não poderá ser revertida. Deseja realmente excluir os usuários selecionados?",
          toastSuccess: "{{count}} usuário(s) excluído(s) com sucesso.",
          toastError: "{{count}} usuário(s) não puderam ser excluídos.",
        },
      },
      companyUsersDrawer: {
        total: "Total: {{- total}} funcionários",
        searchPlaceholder: "Buscar por nome ou email",
        empty: "Esta empresa ainda não tem funcionários",
        noMatch: "Nenhum funcionário corresponde à busca",
        noQueue: "Sem setor",
        retry: "Tentar novamente",
        errors: {
          fetch: "Não foi possível carregar os funcionários",
        },
        profile: {
          admin: "Admin",
          user: "Funcionário",
        },
        columns: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          queues: "Setores",
        },
      },
      compaies: {
        title: "Empresas",
        bulkDelete: {
          selected: "{{count}} selecionada(s)",
          clear: "Limpar",
          button: "Excluir selecionadas",
          dialogTitle: "Excluir empresas selecionadas",
          dialogIntro: "Você está prestes a excluir {{count}} empresa(s):",
          dialogWarning: "Todos os dados destas empresas (funcionários, atendimentos, mensagens, conexões WhatsApp e assinaturas Asaas) serão excluídos permanentemente. Esta ação não pode ser desfeita.",
          confirmWord: "EXCLUIR",
          confirmInputLabel: "Digite {{word}} para confirmar",
          confirm: "Excluir",
          cancel: "Cancelar",
          deleting: "Excluindo...",
          failuresTitle: "Falhas durante a exclusão",
          toastAllOk: "{{count}} empresa(s) excluída(s) com sucesso",
          toastPartial: "{{ok}} excluída(s), {{failed}} falharam",
          toastError: "Não foi possível excluir as empresas",
        },
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Último Login",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Cancelar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
          employees: "Funcionários",
          employeesTooltip: "Ver funcionários",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        year: "Ano",
        stats: {
          total: "Total",
          sent: "Enviadas",
          errors: "Erros",
          pending: "Pendentes",
        },
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ Adicionar/Editar colunas",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },
      tagsKanban: {
        stage: "Etapa CRM",
        title: "Colunas",
        laneDefault: "Em aberto",
        backToKanban: "Voltar para o CRM",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Coluna?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Coluna",
        },
        toasts: {
          deleted: "Coluna excluída com sucesso.",
        },
      },
      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket: "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues: "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket: "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact: "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer: "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets: "Mover automaticamente cliente para carteira",
            showNotificationPending: "Mostrar notificação para tickets pendentes",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage: "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage: "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle: "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage: "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage: "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen: "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed: "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message: "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
        upload: {
          uploading: "Enviando... {{percent}}%",
          finishing: "Enviando ao WhatsApp...",
          tooLarge: "{{category}} muito grande ({{size}} MB). Máximo permitido pelo WhatsApp: {{limit}} MB.",
          category: {
            image: "Imagem",
            video: "Vídeo",
            audio: "Áudio",
            document: "Documento",
          },
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_NO_FILE_UPLOADED: "Nenhum arquivo enviado.",
        ERR_AI_KNOWLEDGE_FILE_MUST_BE_PDF: "O arquivo deve ser um PDF.",
        ERR_AI_KNOWLEDGE_FILE_TOO_LARGE: "O arquivo excede o limite de 5MB.",
        ERR_AI_KNOWLEDGE_MISSING_PARAMS: "Faltam informações para enviar o arquivo. Salve o nó antes de anexar PDFs.",
        ERR_NO_AI_KNOWLEDGE_FILE_FOUND: "Arquivo não encontrado.",
        ERR_TICKETNOTE_INVALID_NAME: "O comentário deve ter pelo menos 3 caracteres.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND: "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT: "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS: "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG: "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_DELETE_WAPP_MSG_OFICIAL_NOT_SUPPORTED: "Não é possível excluir mensagens em conexões API Oficial (Meta) — a Meta não permite essa ação.",
        ERR_EDITING_WAPP_MSG_OFICIAL_NOT_SUPPORTED: "Não é possível editar mensagens em conexões API Oficial (Meta) — a Meta não permite essa ação.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED: "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_INVALID_COUNTRY_CODE: "Código de país inválido.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_FLOW_NOT_FOUND: "Fluxo não encontrado.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG: "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED: "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_INVALID_PASSWORD: "A senha deve conter letras maiúsculas, minúsculas, números e caracteres especiais.",
        ERR_INVALID_RESET_CODE: "Código de verificação inválido.",
        ERR_RESET_CODE_EXPIRED: "Código de verificação expirado. Solicite um novo.",
        ERR_LIMIT_EXCEEDED: "Muitas tentativas. Aguarde alguns minutos.",
        ERR_MISSING_EMAIL: "Email é obrigatório.",
        ERR_MISSING_RESET_PARAMS: "Preencha todos os campos.",
        ERR_CANNOT_REMOVE_GROUP_ADMIN: "Não é possível remover o administrador do grupo.",
        ERR_CHATBOT_NOT_FOUND_SERVICE: "Serviço de chatbot não encontrado.",
        ERR_CHAT_IS_NOT_GROUP: "Este chat não é um grupo.",
        ERR_CHAT_NOT_FOUND: "Chat não encontrado.",
        ERR_CHECK_NUMBER: "Não foi possível verificar o número. Verifique e tente novamente.",
        ERR_CODE_EXPIRED: "Código de verificação expirado.",
        ERR_COGNITO_AUTH_FAILED: "Falha na autenticação. Por favor, tente novamente.",
        ERR_COGNITO_UPDATE_EMAIL: "Erro ao atualizar email. Por favor, tente novamente.",
        ERR_EMAIL_ALREADY_IN_USE: "Este email já está cadastrado. Por favor, use um endereço de email diferente.",
        ERR_COGNITO_UPDATE_PASSWORD: "Erro ao atualizar senha. Por favor, tente novamente.",
        ERR_COGNITO_USER_ALREADY_EXISTS: "Já existe um usuário com este email.",
        ERR_COMPANY_INACTIVE: "Seu plano expirou. Escolha um plano para continuar.",
        ERR_COMPANY_INVALID_NAME: "Informe um nome válido para a empresa (mínimo 2 caracteres).",
        ERR_COGNITO_USER_CREATION: "Erro ao criar conta de usuário. Por favor, tente novamente.",
        ERR_COGNITO_USER_CREATION_NO_SUB: "Erro ao criar conta de usuário. Entre em contato com o suporte.",
        ERR_CONTACT_NOT_FOUND: "Contato não encontrado.",
        ERR_DUPLICATED_FINALIZATION_REASON: "Este motivo de finalização já existe.",
        ERR_EDITING_WAPP_MSG: "Erro ao editar mensagem do WhatsApp.",
        ERR_EMPTY_MESSAGE: "A mensagem não pode estar vazia.",
        ERR_FINALIZATION_REASON_NOT_FOUND: "Motivo de finalização não encontrado.",
        ERR_FORBIDDEN_ACK_TARGET_COMPANY: "Você não tem permissão para esta ação.",
        ERR_GROUP_MUST_HAVE_AT_LEAST_2_USERS: "Um grupo deve ter pelo menos 2 usuários.",
        ERR_INVALID_MEDIA_TYPE: "Tipo de mídia inválido. Tipos suportados: imagem, áudio, vídeo e documento.",
        ERR_INVALID_NUMBER: "Número inválido. Verifique e tente novamente.",
        ERR_INVALID_PARAMETER: "Parâmetro inválido.",
        ERR_INVALID_TOTP_CODE: "Código de verificação inválido. Verifique e tente novamente.",
        ERR_MFA_NOT_CONFIGURED: "Autenticação em duas etapas não está configurada para esta conta.",
        ERR_MFA_SETUP_FAILED: "Erro ao configurar autenticação em duas etapas. Por favor, tente novamente.",
        ERR_MISSING_CHALLENGE_PARAMS: "Parâmetros obrigatórios ausentes. Por favor, tente novamente.",
        ERR_MISSING_CREDENTIALS: "Email e senha são obrigatórios.",
        ERR_MISSING_NEW_PASSWORD: "Nova senha é obrigatória.",
        ERR_MISSING_REFRESH_PARAMS: "Parâmetros obrigatórios para renovar sessão ausentes.",
        ERR_MISSING_TOTP_CODE: "Código de verificação é obrigatório.",
        ERR_NO_ANNOUNCEMENT_FOUND: "Informativo não encontrado.",
        ERR_NO_BAILEYS_DATA_FOUND: "Dados da sessão do WhatsApp não encontrados.",
        ERR_NO_CAMPAIGN_FOUND: "Campanha não encontrada.",
        ERR_NO_CHATBOT_FOUND: "Chatbot não encontrado.",
        ERR_NO_CHAT_FOUND: "Chat não encontrado.",
        ERR_NO_COMPANY_FOUND: "Empresa não encontrada.",
        ERR_NO_CONTACTLIST_FOUND: "Lista de contatos não encontrada.",
        ERR_NO_CONTACTLISTITEM_FOUND: "Item da lista de contatos não encontrado.",
        ERR_NO_DIALOG_CHATBOT_FOUND: "Diálogo do chatbot não encontrado.",
        ERR_NO_DIALOG_FOUND: "Diálogo não encontrado.",
        ERR_NO_FILE_FOUND: "Arquivo não encontrado.",
        ERR_NO_HELP_FOUND: "Artigo de ajuda não encontrado.",
        ERR_NO_INTEGRATIONS_FOUND: "Integração não encontrada.",
        ERR_NO_INVOICE_FOUND: "Fatura não encontrada.",
        ERR_INVOICE_NOT_ASAAS_LINKED: "Esta fatura não está vinculada a uma cobrança no Asaas.",
        ERR_INVOICE_ASAAS_LINKED_CANNOT_MANUALLY_EDIT: "Esta fatura está vinculada a uma cobrança real no Asaas — o status é atualizado automaticamente pelo Asaas e não pode ser alterado manualmente.",
        ERR_INVOICE_INVALID_STATUS_TRANSITION: "Essa mudança de status não é permitida a partir do status atual da fatura.",
        ERR_NO_PARTNER_FOUND: "Parceiro não encontrado.",
        ERR_NO_PLAN_FOUND: "Plano não encontrado.",
        ERR_NO_PROMPT_FOUND: "Prompt não encontrado.",
        ERR_NO_QUICKMESSAGE_FOUND: "Resposta rápida não encontrada.",
        ERR_NO_RATING_FOUND: "Avaliação não encontrada.",
        ERR_NO_SCHEDULE_FOUND: "Agendamento não encontrado.",
        ERR_NO_TAG_FOUND: "Tag não encontrada.",
        ERR_NOT_FOUND_USER_IN_QUEUE: "Usuário não encontrado na fila.",
        ERR_NO_TICKETNOTE_FOUND: "Nota do ticket não encontrada.",
        ERR_NOT_MESSAGE_TO_IMPORT: "Nenhuma mensagem para importar.",
        ERR_NO_USERS_IN_QUEUE: "Nenhum usuário disponível nesta fila.",
        ERR_PASSWORD_RESET_REQUIRED: "Redefinição de senha necessária. Por favor, redefina sua senha.",
        ERR_QUEUE_NOT_FOUND: "Fila não encontrada.",
        ERR_REFRESH_FAILED: "Falha ao renovar sessão. Por favor, faça login novamente.",
        ERR_SENDING_FACEBOOK_MSG: "Erro ao enviar mensagem do Facebook. Verifique a página de conexões.",
        ERR_SENDING_WAPP_MSG_GROUP_BLOCKED: "Este grupo foi bloqueado. Não é possível enviar mensagens.",
        ERR_TEST_REPLY_DIALOG: "Erro ao testar diálogo de resposta do chatbot.",
        ERR_TEST_SESSION_DIALOG: "Erro ao testar diálogo de sessão do chatbot.",
        ERR_UNSUPPORTED_CHALLENGE: "Desafio de autenticação não suportado. Entre em contato com o suporte.",
        ERR_USER_NOT_CONFIRMED: "Conta de usuário não confirmada. Verifique seu email.",
        ERR_USER_NOT_FOUND: "Usuário não encontrado.",
        ERR_USER_QUEUE_NOT_FOUND: "Fila do usuário não encontrada.",
        ERR_PLAN_NOT_FOUND: "Plano não encontrado.",
        ERR_PLAN_IS_TRIAL_USE_TRIAL_FLOW: "Este plano é somente para teste.",
        ERR_PLAN_INVALID_AMOUNT: "Valor do plano inválido. Contate o suporte.",
        ERR_INVALID_PAYMENT_FLOW: "Forma de pagamento inválida.",
        ERR_PLAN_PAYMENT_METHOD_NOT_ALLOWED: "Esta forma de pagamento não está disponível para o plano selecionado.",
        ERR_PLAN_NAME_RECURRENCE_UNPARSEABLE: "Erro de configuração do plano. Contate o suporte.",
        ERR_PLAN_NAME_BILLING_UNPARSEABLE: "Erro de configuração do plano. Contate o suporte.",
        ERR_ASAAS_FIRST_PAYMENT_NO_INVOICE_URL: "Erro ao gerar pagamento. Tente novamente.",
        ERR_ASAAS_BAD_REQUEST: "Não foi possível gerar o pagamento. Verifique seus dados e tente novamente.",
        ERR_ASAAS_UNAUTHORIZED: "Erro de configuração do gateway de pagamento. Contate o suporte.",
        ERR_ASAAS_HTTP_ERROR: "Gateway de pagamento indisponível. Tente novamente em alguns minutos.",
        ERR_ASAAS_NETWORK: "Não foi possível conectar ao gateway de pagamento. Tente novamente.",
        ERR_ASAAS_API_KEY_MISSING: "Erro de configuração do gateway de pagamento. Contate o suporte.",
        ERR_ASAAS_CALLBACK_DOMAIN_NOT_REGISTERED: "O domínio de redirecionamento não está cadastrado no gateway de pagamento. Contate o suporte.",
        ERR_SIGNUP_ASAAS_FAILED: "Erro ao criar conta. Tente novamente.",
        ERR_INVALID_INSTALLMENT_COUNT: "Número de parcelas inválido para este plano.",
        ERR_INSTALLMENT_LOCK_IN_EFFECT: "Você ainda tem parcelas em andamento do plano atual. Aguarde o término para trocar de plano.",
        ERR_ACTIVE_PLAN_SWITCH_BLOCKED: "Você já tem um plano ativo. Para trocar de plano, aguarde o término do período atual.",
        ERR_NO_RECURRING_RESOURCE_TO_CANCEL: "Não há renovação automática para cancelar neste plano.",
        ERR_COMPANY_ALREADY_INACTIVE: "Sua assinatura já está inativa.",
        ERR_SUBSCRIPTION_ALREADY_ACTIVE: "Sua assinatura já está ativa. Não é necessário reativá-la.",
        ERR_NO_CREDIT_CARD_TOKEN_TO_REACTIVATE: "Não há um cartão salvo para reativar a assinatura. Aguarde o vencimento e escolha um novo plano.",
        ERR_REACTIVATE_NOT_SUPPORTED_FOR_SUBSCRIPTION: "A reativação automática não está disponível para este plano. Aguarde o vencimento e escolha um novo plano.",
        ERR_COMPANY_NOT_FOUND: "Empresa não encontrada.",
        ERR_BILLING_ADMIN_ONLY: "Apenas administradores podem gerenciar a assinatura da empresa.",
        ERR_INVOICE_NOT_PENDING: "O lembrete só pode ser enviado para faturas pendentes que ainda não venceram.",
        ERR_COMPANY_NO_EMAIL: "Esta empresa não possui um e-mail cadastrado.",
        ERR_MISSING_PAYMENT_FLOW: "Selecione uma forma de pagamento para continuar.",
        ERR_PLAN_IS_TRIAL: "Este é um plano de teste e não pode ser pago. Escolha um plano pago para continuar.",
        ERR_PLAN_NOT_INSTALLMENT: "Este plano não permite parcelamento.",
        ERR_INVALID_COMPANY_ID: "Identificador de empresa inválido.",
        ERR_INVALID_INSTALLMENT_INPUT: "Número de parcelas inválido.",
        ERR_BULK_DELETE_NO_IDS: "Selecione pelo menos uma empresa para excluir.",
        ERR_BULK_DELETE_NO_VALID_IDS: "Nenhuma das empresas selecionadas pode ser excluída.",
        ERR_BULK_DELETE_PROTECTED_COMPANY: "Não é possível excluir uma empresa protegida do sistema.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization: "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: "\"number\": \"558599999999\"",
        fieldBody: "\"body\": \"Mensagem\"",
        fieldUserId: "\"userId\": ID do usuário ou \"\"",
        fieldQueueId: "\"queueId\": ID da Fila ou \"\"",
        fieldSendSignature: "\"sendSignature\": Assinar mensagem - true/false",
        fieldCloseTicket: "\"closeTicket\": Encerrar o ticket - true/false",
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description: "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: " Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: " Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        groupCreated: "Grupo criado com sucesso",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
      whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",
        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema",
        },
      },
      contactList: {
        dialog: "Lista de Contatos",
      },
      frontEndErrors: {
        getUsers: "Erro ao carregar usuários",
      },
      loading: "Carregando...",
      messageModal: {
        success: {
          save: "Mensagem salva com sucesso!",
        },
        title: {
          add: "Adicionar Mensagem",
          edit: "Editar Mensagem",
        },
      },
      quickemessages: {
        toasts: {
          deleted: "Resposta rápida excluída!",
        },
      },
      ticketList: {
        success: {
          integrationTriggered: "Integração disparada com sucesso!",
        },
      },
      webhookModal: {
        saveSuccess: "Webhook salvo com sucesso!",
        title: {
          add: "Adicionar Webhook",
          edit: "Editar Webhook",
        },
        toasts: {
          update: "Webhook atualizado com sucesso!",
        },
      },
      chatBots: {
        confirmDeleteAll: "Tem certeza? Todas as opções internas também serão excluídas.",
      },
      contactImport: {
        title: "Exportar / Importar Contatos",
      },
      platforms: {
        gclick: {
          tabs: {
            aiAgent: "Agente de I.A.",
            app: "Aplicativo",
          },
        },
        table: {
          selected: "{{count}} selecionada(s)",
          delete: {
            dialogTitle: "Excluir integração?",
            toastSuccess: "Integração excluída com sucesso.",
            message:
              "as credenciais salvas serão apagadas. A liberação da empresa continua ativa, então você pode configurar de novo a qualquer momento.",
          },
          bulkDelete: {
            button: "Excluir Selecionadas ({{count}})",
            dialogTitle: "Excluir {{count}} integração(ões) selecionada(s)?",
            dialogMessage:
              "As credenciais salvas serão apagadas. A liberação da empresa continua ativa, então é possível configurar de novo a qualquer momento.",
            confirmWord: "EXCLUIR",
            andMore: "e mais {{count}}",
            confirmLabel: "Digite {{word}} para confirmar",
            toastSuccess: "{{count}} integração(ões) excluída(s) com sucesso.",
            toastPartial:
              "{{deleted}} excluída(s), {{failed}} falharam. As que falharam continuam selecionadas.",
          },
        },
      },
    },
  },
};

export { messages };
